import React, { useRef } from 'react';
import { Camera, X } from 'lucide-react';
import { Button } from './ui/button';

const PhotoUpload = ({ photos, onPhotosChange, maxPhotos = null, disabled = false }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    let newPhotos = [...photos];
    
    for (const file of files) {
      // Verificar límite si existe
      if (maxPhotos && newPhotos.length >= maxPhotos) {
        alert(`Máximo ${maxPhotos} fotos permitidas`);
        break;
      }
      
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          newPhotos.push(reader.result);
          onPhotosChange([...newPhotos]);
        };
        reader.readAsDataURL(file);
      }
    }
    
    e.target.value = '';
  };

  const removePhoto = (index) => {
    const newPhotos = photos.filter((_, i) => i !== index);
    onPhotosChange(newPhotos);
  };

  const canAddMore = maxPhotos ? photos.length < maxPhotos : true;

  return (
    <div className="space-y-3" data-testid="photo-upload">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        onChange={handleFileChange}
        className="hidden"
        data-testid="photo-input"
        disabled={disabled}
      />
      
      <Button
        type="button"
        variant="outline"
        onClick={() => fileInputRef.current?.click()}
        className="w-full"
        data-testid="photo-upload-button"
        disabled={disabled || !canAddMore}
      >
        <Camera className="mr-2 h-4 w-4" />
        {maxPhotos ? `Agregar Fotos (${photos.length}/${maxPhotos})` : 'Agregar Fotos'}
      </Button>
      
      {photos.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {photos.map((photo, index) => (
            <div key={index} className="relative group" data-testid={`photo-item-${index}`}>
              <img
                src={photo}
                alt={`Foto ${index + 1}`}
                className="w-full h-32 object-cover rounded-lg border border-gray-200"
              />
              <button
                type="button"
                onClick={() => removePhoto(index)}
                disabled={disabled}
                className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid={`photo-remove-${index}`}
              >
                <X size={16} />
              </button>
            </div>
          ))}
        </div>
      )}
      
      {photos.length > 0 && (
        <p className="text-sm text-gray-600" data-testid="photo-count">
          {photos.length} foto{photos.length !== 1 ? 's' : ''} agregada{photos.length !== 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
};

export default PhotoUpload;